import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CAL_DEMO_BOOKING_URL } from '@app/config';
import { DialogService } from '@app/core';
import { TuiButton } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { RoughNotationModule } from 'ng-rough-notation';
import { PricingContactSalesDialogComponent } from '../../../pricing/components/pricing-contact-sales-dialog/pricing-contact-sales-dialog.component';

@Component({
  selector: 'app-enterprise-hero-section',
  imports: [RoughNotationModule, TuiBadge, TuiButton],
  templateUrl: './enterprise-hero-section.component.html',
  styleUrl: './enterprise-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseHeroSectionComponent {
  private readonly dialogService = inject(DialogService);
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;

  protected async handleContactSales(): Promise<void> {
    await this.dialogService.showComponentDialog(
      PricingContactSalesDialogComponent,
    );
  }
}
